<nb-card class="lista-crud">
  <nb-card-header class="head">
    <div class="titulo-bloco">
      <span class="titulo-principal">Pessoas</span>
    </div>
    <button nbButton status="primary" size="medium" class="btn-primario-crud" (click)="abrirDialog()">
      <nb-icon pack="eva" icon="person-add-outline" class="icone-primario-crud"></nb-icon>
      <span>Adicionar pessoa</span>
    </button>
  </nb-card-header>

  <nb-card-body>
    <div class="smart-toolbar">
      <div class="filtro-turma-full filtro-multi-campos">
          <div class="campo-filtro">
            <label class="field-label">Nome</label>
            <nb-form-field>
              <nb-icon nbPrefix pack="eva" icon="person-outline"></nb-icon>
              <input
                nbInput
                fullWidth
                placeholder="Nome — Enter para buscar"
                name="filtroNome"
                [(ngModel)]="filtroNome"
                (keyup.enter)="buscarAgora()"
              />
            </nb-form-field>
          </div>
          <div class="campo-filtro">
            <label class="field-label">CPF</label>
            <nb-form-field>
              <nb-icon nbPrefix pack="eva" icon="hash-outline"></nb-icon>
              <input
                nbInput
                fullWidth
                placeholder="CPF"
                name="filtroCpf"
                [(ngModel)]="filtroCpf"
                (keyup.enter)="buscarAgora()"
              />
            </nb-form-field>
          </div>
          <div class="campo-filtro">
            <label class="field-label">Telefone</label>
            <nb-form-field>
              <nb-icon nbPrefix pack="eva" icon="phone-outline"></nb-icon>
              <input
                nbInput
                fullWidth
                placeholder="Telefone"
                name="filtroTelefone"
                [(ngModel)]="filtroTelefone"
                (keyup.enter)="buscarAgora()"
              />
            </nb-form-field>
          </div>
          <div class="campo-filtro--acoes">
            <button nbButton status="basic" size="small" type="button" (click)="buscarAgora()" title="Buscar agora" aria-label="Buscar agora">
              <nb-icon pack="eva" icon="search-outline"></nb-icon>
            </button>
          </div>
        </div>
    </div>

    <app-barra-carregando *ngIf="carregando"></app-barra-carregando>
    <div class="smart-table-wrap" *ngIf="pessoas.length">
      <table class="smart-table">
        <thead>
          <tr>
            <th appOrdenavel campo="nome" rotuloAcessivel="Nome" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Nome</th>
            <th appOrdenavel campo="cpf" rotuloAcessivel="CPF" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">CPF</th>
            <th appOrdenavel campo="email" rotuloAcessivel="Email" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Email</th>
            <th appOrdenavel campo="telefone" rotuloAcessivel="Telefone" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Telefone</th>
            <th class="col-acoes col-acoes--icones">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let pessoa of pessoas">
            <td data-label="Nome">{{ pessoa.nome }}</td>
            <td data-label="CPF">{{ pessoa.cpf || '—' }}</td>
            <td data-label="Email">{{ pessoa.email || '—' }}</td>
            <td data-label="Telefone">{{ pessoa.telefone || '—' }}</td>
            <td class="col-acoes col-acoes--icones" data-label="Ações">
              <div class="acao-btns acao-btns--inline" role="group">
                <button
                  type="button"
                  nbButton
                  size="small"
                  appearance="outline"
                  status="basic"
                  class="btn-acao"
                  [disabled]="!pessoa.id"
                  (click)="abrirDetalhes(pessoa)"
                  title="Turmas e dados Theos"
                  aria-label="Ver detalhes da pessoa (turmas e Theos)"
                >
                  <nb-icon pack="eva" icon="list-outline"></nb-icon>
                </button>
                <button
                  type="button"
                  nbButton
                  size="small"
                  appearance="outline"
                  status="info"
                  class="btn-acao"
                  (click)="editar(pessoa)"
                  title="Editar"
                  aria-label="Editar pessoa"
                >
                  <nb-icon pack="eva" icon="edit-outline"></nb-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-lista-vazia
      *ngIf="!pessoas.length"
      icone="person-outline"
      [filtrado]="temFiltro"
      mensagem="Nenhum catequizando cadastrado ainda."
      mensagemFiltrado="Nenhum catequizando casa com o recorte atual."
      acaoCriarRotulo="Cadastrar catequizando"
      (criar)="abrirDialog()"
      (verTodos)="limparFiltros()"
    ></app-lista-vazia>

    <div class="lista-paginacao" *ngIf="totalPages > 0">
      <button nbButton size="small" [disabled]="page === 1" (click)="onPageChange(page - 1)">Anterior</button>
      <span>Página {{ page }} de {{ totalPages }}</span>
      <button nbButton size="small" [disabled]="page === totalPages" (click)="onPageChange(page + 1)">Próxima</button>
    </div>
  </nb-card-body>
</nb-card>
